import { render, staticRenderFns } from "./NoticeOverlay.vue?vue&type=template&id=fe386438&"
import script from "./NoticeOverlay.vue?vue&type=script&lang=js&"
export * from "./NoticeOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports